/** @format — Maps backend ui.component `name` → React component */

import PortRecommendationCards from "./cards/PortRecommendationCards";
import TruckingQuoteCard from "./cards/TruckingQuoteCard";
import ShipmentListCard from "./cards/ShipmentListCard";
import TrackingSummaryCard from "./cards/TrackingSummaryCard";
import TrackingMapCard from "./cards/TrackingMapCard";
import TrackingNotFoundCard from "./cards/TrackingNotFoundCard";
import InfoBannerCard from "./cards/InfoBannerCard";

export const AGUI_COMPONENT_REGISTRY = {
  "port.recommendation": PortRecommendationCards,
  "smart.suggestion": PortRecommendationCards,
  "trucking.quote": TruckingQuoteCard,
  "shipment.list": ShipmentListCard,
  "tracking.map": TrackingMapCard,
  "tracking.summary": TrackingSummaryCard,
  "tracking.not_found": TrackingNotFoundCard,
  "info.banner": InfoBannerCard,
};

export function getAguiComponent(name) {
  if (!name || typeof name !== "string") return null;
  const Component = AGUI_COMPONENT_REGISTRY[name];
  return typeof Component === "function" ? Component : null;
}

